import API from '../api/chargingstation.js';

export const chargingstations = {
    state: {
        chargingStations: [],
        chargingStationsLoadStatus: 0,

        chargingStation: {},
        chargingStationLoadStatus: 0,

        chargingStationOperators: [],
        chargingStationOperatorsLoadStatus: 0,

        chargingStationsView: 'map'
    },

    actions: {
        loadChargingStations({ commit, rootState, dispatch }, data) {
            commit('setChargingStations', []);
            commit('setChargingStationsLoadStatus', 1);

            API.getChargingStations(data.minimumPower)
                .then(function(response) {
                    commit('setChargingStations', response.data.data);
                    commit('setChargingStationsLoadStatus', 2);
                })
                .catch(function() {
                    commit('setChargingStations', []);
                    commit('setChargingStationsLoadStatus', 3);
                });
        },

        loadChargingStation({ commit }, data) {
            commit('setChargingStationLoadStatus', 1);

            API.getChargingStation(data.slug)
                .then(function(response) {
                    commit('setChargingStation', response.data.data);
                    commit('setChargingStationLoadStatus', 2);
                })
                .catch(function() {
                    commit('setChargingStation', {});
                    commit('setChargingStationLoadStatus', 3);
                });
        },

        loadChargingStationOperators({ commit }) {
            commit('setChargingStationOperatorsLoadStatus', 1);

            API.getChargingStationOperators()
                .then(function( response) {
                    commit('setChargingStationOperators', response.data);
                    commit('setChargingStationOperatorsLoadStatus', 2);
                })
                .catch(function() {
                    commit('setChargingStationOperators', []);
                    commit('setChargingStationOperatorsLoadStatus', 3);
                });
        },

        changeChargingStationsView({ commit, state, dispatch }, view) {
            commit('setChargingStationsView', view);
        }
    },

    mutations: {
        setChargingStations(state, chargingStations) {
            state.chargingStations = chargingStations;
        },

        setChargingStationsLoadStatus(state, status) {
            state.chargingStationsLoadStatus = status;
        },

        setChargingStation(state, chargingStation) {
            state.chargingStation = chargingStation;
        },

        setChargingStationLoadStatus(state, status) {
            state.chargingStationLoadStatus = status;
        },

        setChargingStationOperators( state, brewMethods ){
            state.chargingStationOperators = brewMethods;
        },

        setChargingStationOperatorsLoadStatus(state, status){
            state.chargingStationOperatorsLoadStatus = status;
        },

        setChargingStationsView(state, view) {
            state.chargingStationsView = view
        }
    },

    getters: {
        getChargingStations(state) {
            return state.chargingStations;
        },

        getChargingStationsLoadStatus(state) {
            return state.chargingStationsLoadStatus;
        },

        getChargingStation(state) {
            return state.chargingStation;
        },

        getChargingStationLoadStatus(state) {
            return state.chargingStationLoadStatus;
        },

        getChargingStationOperators(state) {
            return state.chargingStationOperators;
        },

        getChargingStationOperatorsLoadStatus(state) {
            return state.chargingStationOperatorsLoadStatus;
        },

        getChargingStationsView(state) {
            return state.chargingStationsView;
        }
    }
}
